import type { WaveEventConfig } from './WaveEventConfig';

export const FOX_WAVE_CONFIG: WaveEventConfig = {
  id: 'fox_wave',
  displayName: 'Волна Лис',
  bossType: 'wave_event',

  enemyId: 'fox',
  enemyCount: 20,
  spawnIntervalMs: 75,

  introText: 'ВОЛНА: ЛИСЫ',
  victoryText: 'ВОЛНА ОТРАЖЕНА',
};
